// Новая версия доезжает до людей сама.
//
// Раньше после выкладки надо было сказать каждому: нажмите Ctrl+Shift+R.
// У пресса стоят операторы, на складе кладовщик — объяснять им сочетания
// клавиш и незачем, и некогда, а до тех пор они работают по старому экрану и
// не видят ни новой кнопки, ни исправленной ошибки.
//
// Как узнаём про новую версию: спрашиваем у сервера заголовки index.html.
// В нём прописано имя собранного файла с хэшем содержимого: пересобрали —
// сменилось имя, а с ним и ETag самого index.html. Кэшировать его нельзя,
// об этом заботится nginx, так что ответ всегда свежий.
//
// Когда перезагружаем: НЕ в тот момент, когда узнали. Человек может стоять
// с наполовину введёнными параметрами пресса, и перезагрузка сотрёт их вместе
// со сменой. Ждём момента, когда терять нечего:
//   • переход в другой раздел — там ничего не набрано;
//   • полторы минуты без единого касания и без курсора в поле;
//   • возвращение к вкладке, которую надолго оставили.
//
// И никогда — пока экран сам говорит, что занят (window.__lamtechBusy).

// За чем следить. В собранной версии это index.html: в нём стоит имя чанка
// с хэшем, и при выкладке меняется он сам. А на тренажёре работает дев-сервер
// CRA, и там index.html не меняется никогда — весь код лежит в bundle.js.
// Следить за index.html на тренажёре значит не заметить ни одной правки: он и
// не замечал, и проверять приходилось руками, хотя на заводе всё работало.
function versionMark() {
  const dev = document.querySelector('script[src*="/static/js/bundle.js"]');
  return dev ? '/static/js/bundle.js' : '/index.html';
}

const VERSION_MARK = versionMark();
const CHECK_EVERY = 60 * 1000;      // как часто спрашиваем сервер
const IDLE_BEFORE = 90 * 1000;      // сколько тишины ждать перед перезагрузкой
const AWAY_ENOUGH = 60 * 1000;      // «надолго оставили вкладку» — это сколько

let known = null;         // отпечаток версии, с которой мы загрузились
let pending = false;      // новая версия уже вышла, ждём удобного момента
let lastTouch = Date.now();
let hiddenAt = 0;

async function fingerprint() {
  try {
    const r = await fetch(VERSION_MARK, { method: 'HEAD', cache: 'no-store' });
    if (!r.ok) return null;
    return r.headers.get('etag') || r.headers.get('content-length');
  } catch {
    return null;              // сеть моргнула — просто попробуем позже
  }
}

function busy() {
  if (window.__lamtechBusy) return true;
  // Курсор в поле — значит, что-то набирают прямо сейчас
  const el = document.activeElement;
  if (!el) return false;
  const tag = (el.tagName || '').toLowerCase();
  return tag === 'input' || tag === 'textarea' || tag === 'select'
    || el.isContentEditable;
}

function reloadNow() {
  // Метку оставляем себе: после перезагрузки покажем, что программа обновилась.
  try { sessionStorage.setItem('lamtech_updated', '1'); } catch (e) {}
  window.location.reload();
}

function tryReload() {
  if (!pending || busy()) return;
  if (Date.now() - lastTouch < IDLE_BEFORE) return;
  reloadNow();
}

export function startAutoUpdate() {
  if (window.__lamtechAutoUpdate) return;   // один сторож на вкладку
  window.__lamtechAutoUpdate = true;

  ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(ev =>
    window.addEventListener(ev, () => { lastTouch = Date.now(); },
                            { passive: true, capture: true }));

  fingerprint().then(v => { known = v; });

  setInterval(async () => {
    if (!pending) {
      const v = await fingerprint();
      if (v && known && v !== known) pending = true;
      if (v && !known) known = v;      // первый ответ мог не прийти
    }
    tryReload();
  }, CHECK_EVERY);

  // Ушли и вернулись — самый безобидный момент: работу тут точно прервали.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { hiddenAt = Date.now(); return; }
    lastTouch = Date.now();
    if (pending && !busy() && hiddenAt && Date.now() - hiddenAt > AWAY_ENOUGH) {
      reloadNow();
    }
  });

  // Смена раздела: набранного на прежнем экране уже нет, терять нечего.
  const hook = (name) => {
    const orig = window.history[name];
    window.history[name] = function () {
      const r = orig.apply(this, arguments);
      if (pending && !busy()) setTimeout(reloadNow, 60);
      return r;
    };
  };
  hook('pushState');
  hook('replaceState');
}

/** Экран занят: пока true, программа не перезагрузится. */
export function setBusy(v) { window.__lamtechBusy = !!v; }

/** Была ли перезагрузка ради обновления — чтобы сказать об этом один раз. */
export function tookUpdate() {
  try {
    if (sessionStorage.getItem('lamtech_updated')) {
      sessionStorage.removeItem('lamtech_updated');
      return true;
    }
  } catch (e) {}
  return false;
}
